import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalLateralModule } from '@pacifico/components/modal-side/modal-lateral.module';
import { ModalDirective } from '@pacifico/directives/modal.directive';
import { environment } from '@pacifico/environments/environment';
import { SharedHeaderFooterModule } from '@pacifico/shared/shared-footer-header.module';
//captcha
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './commons/interceptors/error.interceptor';
import { HttpConfigInterceptor } from './commons/interceptors/httpconfig.interceptor';
import { AuthPageModule } from './pages/auth-page/auth-page.module';
import { RecoveryPasswordModule } from './pages/recovery-password-page/recovery-password-page.module';
import { RequestPaswordPageModule } from './pages/request-pasword-page/request-pasword-page.module';
@NgModule({
	declarations: [AppComponent, ModalDirective],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		ReactiveFormsModule,
		AuthPageModule,
		ModalLateralModule,
		FormsModule,
		RecaptchaV3Module,
		SharedHeaderFooterModule,
		RequestPaswordPageModule,
		RecoveryPasswordModule
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpConfigInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true
		},
		{ provide: LOCALE_ID, useValue: 'es-PE' },
		{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.captcha },
		{ provide: 'googleTagManagerId', useValue: environment.GTM_ID }
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
